export default __webpack_public_path__ + "static/media/background_bottom.b10a02bb.png";